import React, { useRef } from 'react';
import './informacion-veh.css';

import { formatFecha } from '../../../utils/dateFormatter';
import DeshabilitarVehiculo from './deshabilitar-vehiculo';

import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';

const InformacionVeh = React.memo(({ vehiculo, onActualizar, showToast, permisos = {} }) => {
  const toast = useRef(null);

  // Si no hay vehículo seleccionado, muestra mensaje informativo de la sección
  if (!vehiculo) {
    return (
      <div className='p-1'>
        <div className="alert alert-primary" role="alert">
          <h5 className="alert-heading">Información general del vehículo</h5>
          <p>
            En este apartado podrá encontrar toda la información general del vehículo seleccionado, 
            como su marca, modelo, año, patente, entre otros datos relevantes.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='p-1'>
      <Toast ref={toast} position="center"/>

      {/* Métricas */}
      <div className="veh-metricas-row">
        {[
          { label: 'Último Kilometraje Registrado', value: vehiculo.kmActual || 0 , unit: 'km' },
          { label: 'Capacidad de Pasajeros',        value: vehiculo.capacidad },
          { label: 'Capacidad de Asientos',         value: vehiculo.asientos },
        ].map(({ label, value, unit }) => (
          <div key={label} className="veh-metricas-col">
            <div className="veh-metricas">
              <div className="veh-metricas-text">{label}</div>
              <div className="veh-metricas-value">
                {value}
                {unit && <span className="veh-metricas-unit">{unit}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Datos generales */}
      <div className="border rounded p-3 mb-3">
        <p className="text-uppercase text-muted small fw-semibold mb-2">Información general</p>
        <div className="row row-cols-2 g-2">
          {[
            { l: 'Tipo',                v: vehiculo.tipo        },
            { l: 'Marca',               v: vehiculo.marca       },
            { l: 'Modelo',              v: vehiculo.modelo      },
            { l: 'Año',                 v: vehiculo.anio         },
            { l: 'Color',               v: vehiculo.color       },
            { l: 'Ciudad en que opera', v: vehiculo.ciudadOpera },
          ].map(({ l, v }) => (
            <div className="veh-info-gral" key={l}>
              <small className="text-muted d-block">{l}</small>
              <span className="fw-semibold">{v}</span>
            </div>
          ))}
        </div>
      </div>
      
      {/* Vencimientos Documentación */}
      <div className="veh-vencimiento-container">
        <p className="veh-vencimiento-title">Vencimientos: Documentación y Permisos</p>
        <div className="veh-vencimiento-content">
          {vencimientos.map(({ label, key }) => {
            const { label: tagLabel, severity } = getVencimientoStatus(vehiculo[key]);
            return (
              <div key={key} className="veh-vencimiento-row">
                <span>{label}</span>
                <div className="veh-vencimiento-date-tag">
                  <span className="text-muted">{formatFecha(vehiculo[key], '/')}</span>
                  <Tag value={tagLabel} severity={severity} className='veh-tag-vencimiento'/>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      {/* DESHABILITAR VEHICULO SELECCIONADO */}
      { permisos.deshabilitar && ( 
        <div className="alert alert-danger m-0" role="alert">
          <h6 className="alert-heading">Deshabilitar el vehículo seleccionado</h6>
          <p>
            Si desea deshabilitar el vehículo seleccionado, puede hacerlo haciendo click en el botón <b> "Deshabilitar Vehículo" </b> ubicado en la parte inferior derecha de esta sección.
            Esto hará que el vehículo ya no esté disponible para su uso en la plataforma, pero no eliminará su información de forma permanente.
          </p>
          <hr />
          <div className='btn-group-end' role='group'>
            <DeshabilitarVehiculo 
              id_vehiculo={vehiculo.id_vehiculo} 
              onSuccess={onActualizar}
              showToast={showToast}/> 
          </div>
        </div>
      )}
    </div>
  )
});

export default InformacionVeh;

const getVencimientoStatus = (fechaStr) => {
  if (!fechaStr) {
    return { label: 'No registrado', severity: 'secondary' };
  }

  const hoy = new Date();
  const fecha = new Date(fechaStr);

  // Validar fecha inválida
  if (isNaN(fecha.getTime())) {
    return { label: 'No válido', severity: 'secondary' };
  }

  const dias = Math.ceil((fecha - hoy) / (1000 * 60 * 60 * 24));
  
  if (dias <= 0)       return { label: 'Vencido',    severity: 'danger'  };
  else if (dias <= 30) return { label: 'Por vencer', severity: 'warning' };
  
  return { label: 'Vigente', severity: 'success' };
};

const vencimientos = [
  { label: 'Decreto 80',             key: 'vencDecreto80'          },
  { label: 'Mantención Extintor',    key: 'vencExtintor'           },
  { label: 'Permiso de circulación', key: 'vencPermisoCirculacion' },
  { label: 'Revisión técnica',       key: 'vencRevisionTecnica'    },
];